/**
 * CDN asset utility
 * All static assets are served from DigitalOcean Spaces CDN.
 * Set REACT_APP_CDN_URL in .env to your Spaces CDN endpoint.
 */
const CDN_BASE = process.env.REACT_APP_CDN_URL || '';

/**
 * Build a full CDN URL for an asset.
 * @param {string} path - path relative to the assets folder, e.g. "homepage/ai_bg.png"
 * @returns {string} full CDN URL
 */
export const cdnAsset = (path) => `${CDN_BASE}/assets/${path}`;

/**
 * Helper factories matching the existing getImage / getHomeImage / getDiplomaImage pattern.
 * Usage:  const getImage = cdnFolder('homepage');
 *         getImage('ai_bg.png')  →  https://sdny.nyc3.cdn.digitaloceanspaces.com/assets/homepage/ai_bg.png
 */
export const cdnFolder = (folder) => (name) => `${CDN_BASE}/assets/${folder}/${name}`;

export default CDN_BASE;
